module.exports = {
  "./packages/react-aria-components/stories/Autocomplete.stories.tsx": () => import("../../../packages/react-aria-components/stories/Autocomplete.stories.tsx"),

  "./packages/react-aria-components/stories/Breadcrumbs.stories.tsx": () => import("../../../packages/react-aria-components/stories/Breadcrumbs.stories.tsx"),

  "./packages/react-aria-components/stories/Button.stories.tsx": () => import("../../../packages/react-aria-components/stories/Button.stories.tsx"),

  "./packages/react-aria-components/stories/Calendar.stories.tsx": () => import("../../../packages/react-aria-components/stories/Calendar.stories.tsx"),

  "./packages/react-aria-components/stories/Checkbox.stories.tsx": () => import("../../../packages/react-aria-components/stories/Checkbox.stories.tsx"),

  "./packages/react-aria-components/stories/CheckboxGroup.stories.tsx": () => import("../../../packages/react-aria-components/stories/CheckboxGroup.stories.tsx"),

  "./packages/react-aria-components/stories/ColorArea.stories.tsx": () => import("../../../packages/react-aria-components/stories/ColorArea.stories.tsx"),

  "./packages/react-aria-components/stories/ColorField.stories.tsx": () => import("../../../packages/react-aria-components/stories/ColorField.stories.tsx"),

  "./packages/react-aria-components/stories/ColorPicker.stories.tsx": () => import("../../../packages/react-aria-components/stories/ColorPicker.stories.tsx"),

  "./packages/react-aria-components/stories/ColorSlider.stories.tsx": () => import("../../../packages/react-aria-components/stories/ColorSlider.stories.tsx"),

  "./packages/react-aria-components/stories/ColorSwatch.stories.tsx": () => import("../../../packages/react-aria-components/stories/ColorSwatch.stories.tsx"),

  "./packages/react-aria-components/stories/ColorWheel.stories.tsx": () => import("../../../packages/react-aria-components/stories/ColorWheel.stories.tsx"),

  "./packages/react-aria-components/stories/ComboBox.stories.tsx": () => import("../../../packages/react-aria-components/stories/ComboBox.stories.tsx"),

  "./packages/react-aria-components/stories/ComboBoxReproductions.stories.tsx": () => import("../../../packages/react-aria-components/stories/ComboBoxReproductions.stories.tsx"),

  "./packages/react-aria-components/stories/DateField.stories.tsx": () => import("../../../packages/react-aria-components/stories/DateField.stories.tsx"),

  "./packages/react-aria-components/stories/DatePicker.stories.tsx": () => import("../../../packages/react-aria-components/stories/DatePicker.stories.tsx"),

  "./packages/react-aria-components/stories/Disclosure.stories.tsx": () => import("../../../packages/react-aria-components/stories/Disclosure.stories.tsx"),

  "./packages/react-aria-components/stories/Dropzone.stories.tsx": () => import("../../../packages/react-aria-components/stories/Dropzone.stories.tsx"),

  "./packages/react-aria-components/stories/FileTrigger.stories.tsx": () => import("../../../packages/react-aria-components/stories/FileTrigger.stories.tsx"),

  "./packages/react-aria-components/stories/Form.stories.tsx": () => import("../../../packages/react-aria-components/stories/Form.stories.tsx"),

  "./packages/react-aria-components/stories/GridList.stories.tsx": () => import("../../../packages/react-aria-components/stories/GridList.stories.tsx"),

  "./packages/react-aria-components/stories/Link.stories.tsx": () => import("../../../packages/react-aria-components/stories/Link.stories.tsx"),

  "./packages/react-aria-components/stories/ListBox.stories.tsx": () => import("../../../packages/react-aria-components/stories/ListBox.stories.tsx"),

  "./packages/react-aria-components/stories/Menu.stories.tsx": () => import("../../../packages/react-aria-components/stories/Menu.stories.tsx"),

  "./packages/react-aria-components/stories/Meter.stories.tsx": () => import("../../../packages/react-aria-components/stories/Meter.stories.tsx"),

  "./packages/react-aria-components/stories/Modal.stories.tsx": () => import("../../../packages/react-aria-components/stories/Modal.stories.tsx"),

  "./packages/react-aria-components/stories/NumberField.stories.tsx": () => import("../../../packages/react-aria-components/stories/NumberField.stories.tsx"),

  "./packages/react-aria-components/stories/Popover.stories.tsx": () => import("../../../packages/react-aria-components/stories/Popover.stories.tsx"),

  "./packages/react-aria-components/stories/ProgressBar.stories.tsx": () => import("../../../packages/react-aria-components/stories/ProgressBar.stories.tsx"),

  "./packages/react-aria-components/stories/RadioGroup.stories.tsx": () => import("../../../packages/react-aria-components/stories/RadioGroup.stories.tsx"),

  "./packages/react-aria-components/stories/SearchField.stories.tsx": () => import("../../../packages/react-aria-components/stories/SearchField.stories.tsx"),

  "./packages/react-aria-components/stories/Select.stories.tsx": () => import("../../../packages/react-aria-components/stories/Select.stories.tsx"),

  "./packages/react-aria-components/stories/Slider.stories.tsx": () => import("../../../packages/react-aria-components/stories/Slider.stories.tsx"),

  "./packages/react-aria-components/stories/Switch.stories.tsx": () => import("../../../packages/react-aria-components/stories/Switch.stories.tsx"),

  "./packages/react-aria-components/stories/Table.stories.tsx": () => import("../../../packages/react-aria-components/stories/Table.stories.tsx"),

  "./packages/react-aria-components/stories/Tabs.stories.tsx": () => import("../../../packages/react-aria-components/stories/Tabs.stories.tsx"),

  "./packages/react-aria-components/stories/TagGroup.stories.tsx": () => import("../../../packages/react-aria-components/stories/TagGroup.stories.tsx"),

  "./packages/react-aria-components/stories/TextField.stories.tsx": () => import("../../../packages/react-aria-components/stories/TextField.stories.tsx"),

  "./packages/react-aria-components/stories/TimeField.stories.tsx": () => import("../../../packages/react-aria-components/stories/TimeField.stories.tsx"),

  "./packages/react-aria-components/stories/ToggleButton.stories.tsx": () => import("../../../packages/react-aria-components/stories/ToggleButton.stories.tsx"),

  "./packages/react-aria-components/stories/Toolbar.stories.tsx": () => import("../../../packages/react-aria-components/stories/Toolbar.stories.tsx"),

  "./packages/react-aria-components/stories/Tooltip.stories.tsx": () => import("../../../packages/react-aria-components/stories/Tooltip.stories.tsx"),

  "./packages/react-aria-components/stories/Tree.stories.tsx": () => import("../../../packages/react-aria-components/stories/Tree.stories.tsx"),

  "./packages/react-aria-components/stories/animations.stories.tsx": () => import("../../../packages/react-aria-components/stories/animations.stories.tsx"),

};
